import Database from './database'
import Dictionary from './dictionary'

export default {
  ...Database,
  ...Dictionary
}
